exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".apptemplate-delete .modal-dialog{width:350px}@media (max-width:768px){.apptemplate-delete .modal-dialog{top:30%}}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ../~/css-loader!./directives/apptemplatesTable/removeModal.css
// module id = 445
// module chunks = 0